import { createFileRoute } from "@tanstack/react-router";
import { CorporateOfficeBrandingPage } from "./services_.corporate-office-branding";

export const Route = createFileRoute("/services_/branding-creatives-and-office-branding-services")({
  head: () => ({
    meta: [
      {
        title: "Corporate Office Branding Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Transforming Workplaces into Inspiring Brand Environments.",
      },
    ],
  }),
  component: CorporateOfficeBrandingPage,
});
